const Logo = ({ size = 46 }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <img
      src="/logo.png"
      alt="The Rayan monogram"
      width={size}
      height={size}
      className="shrink-0 select-none object-contain drop-shadow-[0_0_12px_rgba(197,160,89,0.25)]"
      draggable={false}
    />
    <div className="leading-none">
      <span className="block font-display text-xl font-medium tracking-[0.2em] text-[#F5F2EB]">THE RAYAN</span>
      <span className="mt-1.5 block text-[9px] font-medium tracking-[0.5em] text-[#C5A059]">SRINAGAR</span>
    </div>
  </div>
);

export default Logo;
